/**
* This component is used to get an image tag.
*/

import React, {memo} from 'react';
import { IconPathComp } from '../utils/common';


const ImgIconComp = ({width = '15', height = '15', tabFocus=true, ...props}) => {
  const getWidth = () => {
    const w = width;
    return w;
  }

  const getHeight = () => {
    const h = height;
    return h;
  }

  const getClass = () => {
    const c = props.class ? props.class : '';
    return c;
  }

  const getDataAttr = () => {
    const c = props.attr ? props.attr : '';
    return c;
  }

  const getIconPath = (id) => {
    return IconPathComp(id);
  }

  const getTitle = () => {
    const c = props.title ? props.title : '';
    return c;
  }

  const getAlt = () => {
    const c = props.alt ? props.alt : '';
    return c;
  }

  let inlineStyle = {};
  if (typeof props.style === 'object') {
    inlineStyle = props.style;
  }

  return (
    <img
      src={props.srcUrl ? props.srcUrl : getIconPath(props.id)}
      data-attr={getDataAttr()}
      className={getClass()}
      width={getWidth()}
      height={getHeight()}
      title={getTitle()}
      alt={getAlt()}
      style={inlineStyle}
      onClick={props.onClick}
    />
  );
}

// class ImgIconComp extends React.Component {
//   constructor(props) {
//     super(props);
//     this.getWidth = this.getWidth.bind(this);
//     this.getHeight = this.getHeight.bind(this);
//     this.getClass = this.getClass.bind(this);
//     this.getIconPath = this.getIconPath.bind(this);
//     this.getTitle = this.getTitle.bind(this);
//   }

//   componentDidMount() {
//   }

//   getWidth() {
//     const w = this.props.width;
//     return w;
//   }

//   getHeight() {
//     const h = this.props.height;
//     return h;
//   }

//   getClass() {
//     const c = this.props.class ? this.props.class : '';
//     return c;
//   }

//   getDataAttr() {
//     const c = this.props.attr ? this.props.attr : '';
//     return c;
//   }

//   getIconPath(id) {
//     return IconPathComp(id);
//   }

//   getTitle() {
//     const c = this.props.title ? this.props.title : '';
//     return c;
//   }

//   render() {
//     let inlineStyle = {};
//     if (typeof this.props.style === 'object') {
//       inlineStyle = this.props.style;
//     }
//     return (
//       <img
//         src={this.props.srcUrl ? this.props.srcUrl : this.getIconPath(this.props.id)}
//         data-attr={this.getDataAttr()}
//         className={this.getClass()}
//         width={this.getWidth()}
//         height={this.getHeight()}
//         title={this.getTitle()}
//         style={inlineStyle}
//         onClick={this.props.onClick}
//       />
//     );
//   }
// }

// ImgIconComp.defaultProps = {
//   width: 15,
//   height: 15,
// };

export default memo(ImgIconComp);
